import { z } from "zod";

/**
 * Validates the CloudFront request headers structure.
 */
export const cloudFrontHeadersSchema = z.record(
  z.string(),
  z
    .array(
      z.object({
        key: z.string(),
        value: z.string(),
      }),
    )
    .optional(),
);
